<template>
  <div class="d-flex align-items-center">
    <button
      v-if="location"
      v-b-modal="'dashboardLocations'"
      @click="setLocation"
      class="d-flex align-items-center btn-primary type-text"
    >
      <span class="loc-details">{{ $t('common.view') }}</span>
    </button>

    <p v-else>-</p>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: ["location"],
  methods: {
    ...mapActions("modal"),
    setLocation() {
      this.$store.commit("sites/setLong", this.location.long);
      this.$store.commit("sites/setLat", this.location.lat);
    },
  },
};
</script>

<style lang="scss" scoped>
.type-text {
  justify-content: center;
  width: 70px;
  height: 25px;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  color: #ffffff;
  border: none;
  border-radius: 12.5px;
}
</style>
